import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button
} from '@mui/material';
import {
  ArrowBack,
  VideoCall
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import EnhancedVideoScriptsGenerator from '../components/VideoScripts/EnhancedVideoScriptsGenerator';
import { VideoScriptResponse } from '../services/videoAPI';

export const NewVideoScriptsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleScriptGenerated = (script: VideoScriptResponse) => {
    console.log('Script generated:', script);
    // You can add additional logic here, like saving to state or analytics
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            Back to Dashboard
          </Button>
          <VideoCall color="primary" sx={{ mr: 2, fontSize: 32 }} />
          <Typography variant="h4" component="h1">
            Video Scripts Generator
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Generate high-quality video scripts using our enhanced MCP-powered system with support for multiple platforms and advanced features
        </Typography>
      </Box>

      {/* Enhanced Video Scripts Generator Component */}
      <EnhancedVideoScriptsGenerator
        onScriptGenerated={handleScriptGenerated}
      />
    </Container>
  );
};

export default NewVideoScriptsPage; 